<div
  class="Main-Container"
  [ngStyle]="{ height: height == '10em', 'margin-top': popUp ? '4%' : '0%' }"
  [style]="'height:' + this.height"
>
  <div
    class="metricname-Container"
    title="{{ name[0] }}"
    [ngStyle]="{ display: chartproperties?.showDataLabel ? 'block' : 'none' }"
  >
    {{ name[0] }}
  </div>
  <div
    [id]="'chart-container' + id"
    class="chart-container"
    [ngStyle]="{ height: '90%', width: '100%' }"
  ></div>
  <div
    class="legend-container"
    *ngIf="!notApplicable"
    [ngStyle]="{
      height: '20%',
      width: '100%',
      display: chartproperties?.showDataLabel ? 'flex' : 'none',
    }"
  >
    <div class="widget-value-container">
      <div class="value-container">
        <span
          [ngStyle]="{ 'font-size': chartproperties?.dataLabelSize }"
          [ngStyle]="{ color: chartproperties?.dataLabelColor }"
          [innerHTML]="getValue(data[0], 0)"
        ></span>
        <span
          *ngIf="isOutput && chartproperties.datalabelStyle != 'datalabel'"
          [ngStyle]="{ color: getSigColor(0) }"
          [innerHTML]="getChangeVs(0)"
        ></span>
      </div>
    </div>
  </div>
</div>
